import {withTranslation} from 'react-i18next';

const Constants = {
	DATE_GET_REQUEST_FORMAT: 'YYYY-MM-DD',
	DATE_JSON_FORMAT: 'YYYY-MM-DD',
    DATE_GET_REQUEST_FORMAT_TIME: 'YYYY-MM-DD HH:mm:ss',
	DATE_TIME_FORMAT_ISO: 'dd-MM-yyyy HH:mm:ss',
	DATE_TIME_ISO_FORMAT_PLACEHOLDER: 'dd-mm-rrrr GG:MM:SS',
	DATE_TIME_GG_MM_FORMAT_PLACEHOLDER: 'dd-mm-rrrr GG:MM',
	DATE_TIME_GG_MM_FORMAT_PLACEHOLDERR: 'rrrr-mm-dd GG:MM',
	DATE_TIME_FORMAT: 'DD-MM-YYYY HH:mm:ss',
	DATE_TIME_FORMAT_WITHOUT_SEC: 'DD-MM-YYYY HH:mm',
	DATE_FORMAT: 'DD-MM-YYYY',
	DATE_FORMAT_MONTH: 'MM-YYYY',
	SIMPLE_DATE_FORMAT: 'DD-MM-YYYY',
	POLAND_LOCATION:[52.215933, 19.134422],
	BOOLEAN_OPTIONS:[
		{ value: true, label: 'Tak' },
		{ value: false, label: 'Nie' },
	],
	BOOLEAN_OPTIONS_ONLY_TRUE:[
		{ value: true, label: 'Tak' }
	],
	IMAGE_EXTS: '.gif,.jpg,.jpeg,.png',
	SC_MAX_RESULT: 99999,
	IMAGE_MAX_SIZE: 10000000,
	PROTOCOL_REPORT_MAX_SIZE: 100000000,
	SUCCESS_MSG_LIFE: 15000,
	ERROR_MSG_LIFE: 30000,
	monthOpt: [
		{enumValue: 0, label: 'Styczeń'},
		{enumValue: 1, label: 'Luty'},
		{enumValue: 2, label: 'Marzec'},
		{enumValue: 3, label: 'Kwiecień'},		
		{enumValue: 4, label: 'Maj'},
		{enumValue: 5, label: 'Czerwiec'},
		{enumValue: 6, label: 'Lipiec'},
		{enumValue: 7, label: 'Sierpień'},
		{enumValue: 8, label: 'Wrzesień'},
		{enumValue: 9, label: 'Październik'},
		{enumValue: 10, label: 'Listopad'},
		{enumValue: 11, label: 'Grudzień'},
	],
	ALERT_ICON: 'mdi-clipboard-alert',
	HANDLED_ICON: 'mdi-clipboard-check',
	GREEN: '#00ff15',
	RED: '#ff0000',
	ORANGE: '#ff9500',
	SCREEN_WIDTH_DASHBOARD_PAGINATOR: 2900,
	USER_APPROVED_COLOR: '#f2fff6',
	PM_APPROVED_COLOR: '#94f2b0',

	TO_APPROVE_BY_USER_LEVEL: 0,
	TO_APPROVE_BY_PM_LEVEL: 1,
	PM_APPROVED_LEVEL: 2,
		NONE: "NONE",
    	EMPLOYEE: "EMPLOYEE",
    	ALL: "ALL"
};

export default Constants;
